import { useMemo } from 'react';
import { domainTTPs } from '../data/mitre/attack-mappings';
import { techniqueDetails } from '../data/mitre/technique-details';

export const useTTPDetails = (selectedDomain) => {
  const getCurrentDomainTTPs = useMemo(() => {
    return () => {  // Return a function instead of the direct value
      return domainTTPs[selectedDomain] || [];
    };
  }, [selectedDomain]);

  const getTTPDetails = (ttpId) => {
    return techniqueDetails[ttpId] || null;
  };

  return { getCurrentDomainTTPs, getTTPDetails };
};